import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import MinMonthlyCollectionModalUI from './MinMonthlyCollectionModalUI.js'

class MinMonthlyCollectionModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      minMonthlyCollectionAmount: this.props.loan.minMonthlyCollectionAmountF4 || '',
      minMonthlyCollectionAmountError: null,
    }
  }

  render() {
    return (
      <MinMonthlyCollectionModalUI
        context={this.props.context}
        loan={this.props.loan}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        minMonthlyCollectionAmount={this.state.minMonthlyCollectionAmount}
        onMinMonthlyCollectionAmountChange={(event) => { this.setState({ minMonthlyCollectionAmount: event.target.value }) }}
        minMonthlyCollectionAmountError={this.state.minMonthlyCollectionAmountError}
        setMinMonthlyCollectionAmountError={(error) => { this.setState({ minMonthlyCollectionAmountError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/minMonthlyCollectionAmount`,
      this.onSubmitCallback, {
      minMonthlyCollectionAmount: this.state.minMonthlyCollectionAmount,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick("noBusy")
      }, 10)
    }
  }

  onCancelClick = () => {
    this.setState({
      errorList: null,
      submitted: false,
    })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default MinMonthlyCollectionModalSF
